import React, { Fragment } from 'react';
import { Divider, FormLabel, List } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import ListItem from './ListItem';

function PreviewFiles({
  files,
  name,
  setDisabledForm,
  required = false,
  onUpload,
  handleDelete,
}: any) {
  if (!files.length) {
    return null;
  }

  return (
    <>
      <FormLabel component="legend" required={required} sx={{ pt: 2 }}>
        <FormattedMessage id="POST_FORM.ATTACHMENTS_FILES" /> (pdf, doc, xls, mp3, mp4, ppt,…)
      </FormLabel>

      <List>
        {files.map((file: any, index: any) => (
          <Fragment key={`${name}-${file.name || file.title}`}>
            <ListItem
              name={name}
              file={file}
              setDisabledForm={setDisabledForm}
              onCancel={(fileOrBlobId: any) => handleDelete(fileOrBlobId, file)}
              onUpload={onUpload}
            />
            <Divider component="li" hidden={index === files.length - 1} />
          </Fragment>
        ))}
      </List>
    </>
  );
}

export default PreviewFiles;
